// extracted by mini-css-extract-plugin
module.exports = {"textarea":"textarea_textarea__O5s3L","textareaContainer":"textarea_textareaContainer__vBBcC"};